export const props = [];
export const model = {};
export const computed = {
  realName() {
    return window.localStorage.realName;
  }
};
